"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var tooltip_1 = require("../tooltip");
var progressBar_1 = require("../progressBar");
var Slider = /** @class */ (function (_super) {
    tslib_1.__extends(Slider, _super);
    function Slider(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onResize = function (e, callback) {
            var vertical = _this.props.vertical;
            var _a = _this.$slider.getBoundingClientRect(), left = _a.left, right = _a.right, top = _a.top, bottom = _a.bottom;
            var cb = (callback) || utils_1.noop;
            var nextState = vertical ?
                {
                    sliderStart: bottom,
                    sliderLength: top - bottom
                } : {
                sliderStart: left,
                sliderLength: right - left
            };
            _this.setState(nextState, cb);
        };
        _this.onIntersection = function (entries) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    _this.onResize();
                }
            });
        };
        _this.roundValue = function (value) {
            return utils_1.round(value, _this.stepDecimals());
        };
        _this.onMouseMove = function (e) {
            utils_1.pauseEvent(e);
            _this.move(utils_1.getMousePosition(e));
        };
        _this.onMouseUp = function (e) {
            _this.end(_this.getMouseEventMap());
        };
        _this.onMouseDown = function (e) {
            _this.start(utils_1.getMousePosition(e));
            utils_1.addEventsToDocument(_this.getMouseEventMap());
            utils_1.pauseEvent(e);
        };
        _this.onMouseEnter = function (e) {
            _this.setState({ hover: true });
        };
        _this.onMouseLeave = function (e) {
            _this.setState({ hover: false });
        };
        _this.onTouchMove = function (e) {
            _this.move(utils_1.getTouchPosition(e));
        };
        _this.onTouchEnd = function (e) {
            _this.move(utils_1.getTouchPosition(e));
        };
        _this.onTouchStart = function (e) {
            _this.start(utils_1.getTouchPosition(e));
            utils_1.addEventsToDocument(_this.getTouchEventMap());
            utils_1.pauseEvent(e);
        };
        _this.setRef = function (el) {
            _this.$slider = el;
        };
        _this.$slider = null;
        _this.intersectionObserver = new IntersectionObserver(_this.onIntersection);
        _this.state = { sliderLength: 0, sliderStart: 0, dragging: false, hover: false };
        return _this;
    }
    Slider.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.onResize);
        this.intersectionObserver.observe(this.$slider);
        this.onResize();
    };
    Slider.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.onResize);
        utils_1.removeEventsFromDocument(this.getMouseEventMap());
        utils_1.removeEventsFromDocument(this.getTouchEventMap());
        this.intersectionObserver.disconnect();
    };
    Slider.prototype.getMouseEventMap = function () {
        return {
            mousemove: this.onMouseMove,
            mouseup: this.onMouseUp
        };
    };
    Slider.prototype.getTouchEventMap = function () {
        return {
            touchmove: this.onTouchMove,
            touchend: this.onTouchEnd
        };
    };
    Slider.prototype.start = function (position) {
        var _this = this;
        this.onResize(null, function () {
            _this.setState({ dragging: true });
            _this.props.onChange(_this.positionToValue(position));
        });
    };
    Slider.prototype.move = function (position) {
        var newValue = this.positionToValue(position);
        if (newValue !== this.props.value) {
            this.props.onChange(newValue);
        }
    };
    Slider.prototype.end = function (events) {
        utils_1.removeEventsFromDocument(events);
        this.setState({ dragging: false });
    };
    Slider.prototype.positionToValue = function (position) {
        var vertical = this.props.vertical;
        var _a = this.state, start = _a.sliderStart, length = _a.sliderLength;
        var _b = this.props, max = _b.max, min = _b.min, step = _b.step;
        var pos = ((vertical ? position.y : position.x) - start) / length * (max - min);
        return this.trimValue(Math.round(pos / step) * step + min);
    };
    Slider.prototype.trimValue = function (value) {
        var _a = this.props, min = _a.min, max = _a.max;
        return utils_1.ensureValueInRange(value, { max: max, min: min }, this.roundValue);
    };
    Slider.prototype.stepDecimals = function () {
        return (this.props.step.toString().split(".")[1] || []).length;
    };
    Slider.prototype.dotOffset = function () {
        var _a = this.props, max = _a.max, min = _a.min;
        var translated = this.state.sliderLength * (this.props.value - min) / (max - min);
        return Math.min(100, translated * 100 / this.state.sliderLength);
    };
    Slider.prototype.renderPoints = function () {
        if (this.props.points) {
            var _a = this.props, max = _a.max, min = _a.min, step = _a.step, theme_1 = _a.theme;
            return (React.createElement("div", { className: theme_1.points }, utils_1.range(0, (max - min) / step).map(function (i) { return React.createElement("div", { key: "span-" + i, className: theme_1.point }); })));
        }
    };
    Slider.prototype.render = function () {
        var _a, _b, _c;
        var _d = this.props, children = _d.children, className = _d.className, theme = _d.theme, name = _d.name, min = _d.min, max = _d.max, step = _d.step, tooltipFormater = _d.tooltipFormater, tooltipPosition = _d.tooltipPosition, value = _d.value, disabled = _d.disabled, vertical = _d.vertical, orange = _d.orange, green = _d.green, red = _d.red, yellow = _d.yellow, others = tslib_1.__rest(_d, ["children", "className", "theme", "name", "min", "max", "step", "tooltipFormater", "tooltipPosition", "value", "disabled", "vertical", "orange", "green", "red", "yellow"]);
        var classes = classnames_1.default(theme.slider, className, (_a = {},
            _a[theme.vertical] = vertical,
            _a[theme.orange] = orange,
            _a[theme.green] = green,
            _a[theme.red] = red,
            _a[theme.yellow] = yellow,
            _a));
        var dotClasses = classnames_1.default(theme.dot, (_b = {},
            _b[theme.dragging] = this.state.dragging,
            _b));
        var offset = this.dotOffset();
        var dotStyles = (_c = {},
            _c[vertical ? "bottom" : "left"] = (offset || value) + "%",
            _c);
        return (React.createElement("div", { className: classes, ref: this.setRef, onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart, onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave },
            React.createElement(tooltip_1.default, { position: tooltipPosition, title: tooltipFormater(value), show: this.state.hover || this.state.dragging },
                React.createElement("div", { className: dotClasses, onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart, style: dotStyles })),
            this.renderPoints(),
            React.createElement(progressBar_1.default, { min: min, animated: false, orange: orange, green: green, red: red, yellow: yellow, max: max, value: value, vertical: vertical })));
    };
    Slider.defaultProps = {
        tooltipFormater: utils_1.echo,
        tooltipPosition: "top",
        onChange: utils_1.noop,
        vertical: false,
        disabled: false,
        points: false,
        step: 1,
        min: 0,
        max: 100
    };
    return Slider;
}(React.Component));
exports.default = Slider;
